import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { MaintenanceCategoryComponent } from './components/maintenance-category.component';
import { MaintenanceCategoryRoutingModule } from './maintenance-category-routing.module';

@NgModule({
  declarations: [MaintenanceCategoryComponent],
  imports: [
    MaintenanceCategoryRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class MaintenanceCategoryModule {}

export function loadMaintenanceCategoryModuleAsChild() {
  return Promise.resolve(MaintenanceCategoryModule);
}
